var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datasets-details-dataset-wrapper"},[_c('dataset-details-dataset-base',{attrs:{"disable-translation-alert":"","disable-incorrect-date-alert":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }